import React, {useContext, useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Form, Table, Pagination, Offcanvas, InputGroup, Button } from 'react-bootstrap'
import { FaPlus } from "react-icons/fa";
import { GoDownload } from "react-icons/go";
import DeleteModal from "../../components/common/DeleteModel";
import { UserContext } from "../../context/UserContextProvider";
import { formatDateTime } from "../../utils/Helper";
import APIServicenew from "../../utils/APIGeneralService";
import useMenuPermissions from "../../components/CustomHook/custompermission";
import Notauthorized from "../../components/Not-authorized/notauthorized";
import { ToastContainer, toast } from "react-toastify";
import Paginator from "../../components/common/Pagination";
import * as XLSX from 'xlsx';

const ProductManagement = () => {
    const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
    const authToken = process.env.REACT_APP_authToken;
    const { accessToken,logout } = useContext(UserContext);
    const headers = { "auth-token": authToken, authorization: accessToken };
    const permissionscontext = useMenuPermissions('/admin/products');
    const [show, setShow] = useState(false);
    const navigate = useNavigate();
    const limit = 10;
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [ dataList ,setDataList] = useState([])
    const [count,setCount]=useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [showDt, setShowDt] = useState(false);
    const [selectedId , setSelectedId] = useState("");
    const fileInputRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState({
      productName: "",
      status: "",
    });
    const [flag ,setFlag] = useState(false)
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
        useEffect(() => {
        fetchData(currentPage);
        }, [currentPage ,flag]);
    
        const fetchData = async (page = 1) => {
            const skip = (page - 1) * limit;
            
            try {
              const response = await APIServices.get(
                `/admin/product/list?offset=${skip}&limit=${limit}&name=${searchTerm?.productName}&status=${searchTerm.status}`,
                headers
              );
              if (response?.status === 200) {
                const data1 = response?.data?.list || [];
                setDataList(data1);
                setCount(response?.data?.count)
                const totalItems = response?.data?.count || 0;
                setTotalCount(Math.ceil(totalItems / limit));
                setShow(false)
                setFlag(false)
                } else if(response?.status === 401){
                logout();
                navigate("/");
               }else {
                setDataList([]);
                setTotalCount(0);
              }
            } catch (error) {
              console.error("Error fetching data:", error);
              setDataList([]);
              setTotalCount(0);
            }
          };
    
      const handleStatusChange = async (it) => {
        const newStatus = it.status === "Active" ? "Inactive" : "Active";
        try {
            const payload = { id: it.id, status: newStatus };
            const res = await APIServices.post(
            `/admin/product/status_update`,
            payload,
            headers
            );
            if (res?.data?.status === true) {
            showToast(res?.data?.message || "Success", "success");
            const updatedFaqs = dataList.map((item) =>
                item.id === it.id ? { ...item, status: newStatus } : item
            );
            setDataList(updatedFaqs);
            } else {
            showToast(res?.data?.message || "Something went wrong.", "error");
            }
        } catch (error) {
            console.error("Error updating status:", error);
            showToast("Error updating status", "error");
        }
        }; 
        const handleDelete = async () => {
            try {
              if (selectedId !== null) {
                const payload = { id: selectedId };
                const res = await APIServices.post(
                  `/admin/product/delete`,
                  payload,
                  headers
                );
                if (res?.data?.status === true) {
                  showToast(res?.data?.message || "Success", "success");
                  const updatedFaqs = dataList.filter((faq) => faq.id !== selectedId);
                  setDataList(updatedFaqs);
                  setSelectedId(null);
                } else {
                  showToast(res?.data?.message || "Something went wrong.", "error");
                }
              }
              setShowDt(false);
            } catch (error) {
              console.error("Error deleting FAQ:", error);
            }
          };

          const handleSearchChange = (e) => {
            setSearchTerm({ ...searchTerm, [e.target.name]: e.target.value });
          };

          const resetDta = () =>{
             setSearchTerm({
                productName: "",
                status: "",
              })
            setShow(false)
          }
         const showToast = (message, type) => {
           toast(message, {
             position: "top-right",
             autoClose: 2000,
             type,
             hideProgressBar: false,
             closeOnClick: true,
           });
         };

         const handleButtonClick = () => {
          fileInputRef.current.click(); 
        };

        const handleFileUpload = (event) => {
          const file = event.target.files[0];
          if (!file) return;
      
          const reader = new FileReader();
          reader.onload = (e) => {
            const binaryStr = e.target.result;
            const workbook = XLSX.read(binaryStr, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet);

            if(jsonData){
              const transformedData = transformExcelData(jsonData)
              if (!transformedData) return;
              if(transformedData){
                handleImport(transformedData)
              }

            }
            event.target.value = null;
      
          };
      
          reader.readAsBinaryString(file);
        };

        const transformExcelData = (data) => {
          if (!Array.isArray(data) || data.length === 0) {
            showToast("Uploaded file is empty or invalid.", "error");
            return null;
          }

          const headers = Object.keys(data[0]);

          const requiredHeaders = ["Product Name", "Description"];
          const hasValidHeaders = requiredHeaders.some(header => headers.includes(header));

          if (!hasValidHeaders) {
            showToast("File must include Product Name, Description", "error");
            return null;
          }

          const transformed = [];
          let currentProduct = null;
        
          data.forEach((row) => {
            const productName = row["Product Name"];
            const description = row["Description"];
        
            if (productName) {
              const product = {
                name: productName,
                description: description || "",
              };
              transformed.push(product);
              currentProduct = product; 
            } 
          });
        
          return transformed;
        };

        const handleImport = async (formData) => {
          try {
        
            const res = await APIServices.post(
              "/admin/product/import",
              formData,
              headers
            );  
            if (res?.data?.status === true) {
              showToast(res?.data?.message || "Success", "success");
               fetchData(currentPage);
            } else {
              showToast(res?.data?.message || "Something went wrong.", "error");
            }
          } catch (error) {
            console.error("Import product error:", error);
            showToast("An unexpected error occurred. Please try again.", "error");
          }
        };
        
        
        
    return (
        <>
            {permissionscontext.view ?  (
        <>
            <div className='momList_inner todo_list_inner product_Management_sec '>
                <div className='mom_header d-flex align-items-center justify-content-between mb-3'>
                    <h1 className='font_blue_18 font-600'>{`Product Management (${count})`}</h1>


                    <ul className="d-flex align-items-center mom_filter">
                        <li className="d-flex align-items-center cursor-pointer" onClick={() => setShow(true)}>
                            Filter By <img src="/images/Sort.svg" className="img-fluid ms-2" alt="Sort" />
                        </li>
                        <li >
                            <button className="btn blue_border d-flex align-items-center" onClick={handleButtonClick}>
                                <GoDownload className="me-1" /> Import Products
                            </button>
                            <input
                              type="file"
                              ref={fileInputRef}
                              accept=".xlsx, .xls"
                              onChange={handleFileUpload}
                              style={{ display: 'none' }}
                            />
                        </li>
                        <li>
                            <button className="btn red_button d-flex align-items-center" onClick={() => navigate("/admin/add-products")}
                              disabled={!permissionscontext.add}>
                                <FaPlus className="me-1" />Add Product
                            </button>
                        </li>
                    </ul>

                </div>

                <div className='todoList_table'>
                    <div className="table-responsive">
                        <Table >
                            <thead className="table-dark">
                                <tr>
                                    <th>Sr.No</th>
                                    <th>Product Name</th>
                                    <th>Date</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            {dataList && dataList?.length > 0 ? (
                              <>
                            <tbody>
                          
                                {dataList && dataList.map((item ,index) => (
                                    <tr key={item.id}>
                                        <td>{(currentPage - 1) * limit + index + 1}</td>
                                      
                                        <td> <Link to={`/admin/product-details/${item.id}`}  className="textTransform">{item.name}</Link></td>
                                        <td>{formatDateTime(item.created)}</td>

                                        <td>
                                            <Form className="Switch_toggle">
                                            <input type="checkbox" id={`switch-${item.id}`} 
                                            checked={item.status === "Active"}
                                            onClick={() => handleStatusChange(item)}
                                            disabled={!permissionscontext.edit}
                                            />
                                            <label  className="position-relative"
                                            htmlFor={`switch-${item.id}`}
                                            >Toggle</label>
                                        </Form>
                                        </td>

                                        <td>
                                            <ul className="d-flex align-items-center justify-content-end gap-2">
                                                <li>
                                                <button
                                                    disabled={!permissionscontext.delete}
                                                    style={{
                                                      border: "none",
                                                      background: "transparent",
                                                      padding: 0,
                                                      cursor: !permissionscontext.delete
                                                        ? "not-allowed"
                                                        : "pointer",
                                                      opacity: !permissionscontext.delete
                                                        ? 0.5
                                                        : 1,
                                                    }}
                                                    onClick={() => {
                                                      setSelectedId(item.id);
                                                      setShowDt(true);
                                                      }}
                                                  >
                                                  <img src="/images/Trash.svg" className={`img-fluid trash`} alt="trash" 
                                                  />
                                                  </button>
                                                </li>
                                                <li> 
                                                <button
                                                  disabled={!permissionscontext.edit}
                                                  style={{
                                                    border: "none",
                                                    background: "transparent",
                                                    padding: 0,
                                                    cursor: !permissionscontext.edit
                                                      ? "not-allowed"
                                                      : "pointer",
                                                    opacity: !permissionscontext.edit
                                                      ? 0.5
                                                      : 1,
                                                  }}
                                                  onClick={() => navigate(`/admin/update-products/${item.id}`, {
                                                    state: { row:item },
                                                  })}
                                                >
                                                  <img src="/images/Pen.svg" className={`img-fluid pen`} alt="pen" 
                                                />
                                                </button>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                ))}
                                
                            </tbody>
                             </>
                            ) : (
                              <>
                             <tbody>
                             <tr>
                               <td colSpan="6" className="border-0">
                                 <div className="d-flex align-items-center justify-content-center mt-5">
                                   <h4>Not Available</h4>
                                 </div>
                               </td>
                             </tr>
                           </tbody>
                              </>
                            )}
                        </Table>
                    </div>
                </div>
            { count > 10 && (

               <Paginator
                currentPage={currentPage}
                totalPages={totalCount}
                onPageChange={handlePageChange}
                />
            )}
            </div>
                <DeleteModal
                showdt={showDt}
                handleCloseDt={() => setShowDt(false)}
                handledelete={handleDelete}
                />

                <Offcanvas className="mom_filter" show={show} onHide={() => setShow(false)} placement="end">
                    <Offcanvas.Header closeButton>
                            <Offcanvas.Title className='font_blue_18 font-600'>Filter By</Offcanvas.Title>
                   </Offcanvas.Header>
                        <Offcanvas.Body className="pt-0">
                        <Form className="filter_form">
                   <div>
                   <label className="font_blue_14 font-500 mb-2">Product Name</label>
                   <Form.Control
                   type="text"
                   placeholder="Search Product..."
                   name="productName"
                   value={searchTerm.productName}
                   onChange={handleSearchChange}
                 />
                 </div>
    
                <div>
                 <label className="font_blue_14 font-500 mb-2">Status</label>
               <Form.Select
                 name="status"
                 value={searchTerm.status}
                 onChange={handleSearchChange}
                 aria-label="Select Status"
               >
                 <option value="">Select Status</option>
                 <option value="Active">Active</option>
                 <option value="Inactive">Inactive</option>
               </Form.Select>
                  </div>
                </Form>
                        </Offcanvas.Body>
    
                    <div className="offcanvas-footer">
                       <button className="btn blue_border"
                       onClick={()=>{resetDta() ; setFlag(true)}} >Clear</button>
                       <button className="btn red_button" onClick={()=>fetchData()}>Apply</button>
                    </div>
                                </Offcanvas>
                <ToastContainer />
                </>)
            :  <Notauthorized />
            }
        </>
    )
}

export default ProductManagement